import { useContext } from 'react';
import "./Admin.scss";
import { Outlet, useNavigate } from 'react-router-dom';
import Sidebar from '../components/Sidebar/Sidebar';
import { Button } from 'primereact/button';
import 'primeicons/primeicons.css';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { confirmDialog } from 'primereact/confirmdialog';
import { MdErrorOutline } from "react-icons/md";
import axios from 'axios';
import { AppContext } from '../context/AppContext';
import { toast } from 'react-toastify';

const Admin = () => {

    const { backendUrl } = useContext(AppContext);
    const navigate = useNavigate();

    const showConfirmLogoutDialog = () => {
        confirmDialog({
            message: (
                <div className="custom-logout-dialog-content">
                    <div className="logout-icon-wrapper">
                        <MdErrorOutline className="logout-icon" />
                    </div>
                    <div className="logout-text-wrapper">
                        <h2>Are you leaving?</h2>
                        <p>Are you sure you want to log out ?</p>
                    </div>
                </div>
            ),
            header: '',
            icon: null,
            acceptLabel: 'Yes',
            rejectLabel: 'Cancel',
            acceptClassName: 'p-button-success custom-yes-btn',
            rejectClassName: 'p-button-text custom-cancel-btn',
            className: 'custom-logout-dialog',
            accept: () => {
                handleLogout();
            }
        });
    };

      async function handleLogout() {
        try {
            axios.defaults.withCredentials = true;
            const { data } = await axios.post(`${backendUrl}/api/auth/logout`, {});
            if (data.success) {
                localStorage.removeItem("authToken");
                              navigate('/', { replace: true });
            }
            window.history.pushState(null, '', window.location.href);
            window.onpopstate = () => {
            window.history.pushState(null, '', window.location.href);
            }
        }
        catch (error) {
            if (error.response && error.response.status === 503) {
                toast.error("⚠️ The service is currently under maintenance. Please try again later.");
            }
            else if (!navigator.onLine) {
                toast.error("🚫 No internet connection. Please check your network.");
            }
            else if (error.request && !error.response) {
                toast.error("⚠️ Network issue or server is unreachable. Try again later.")
            }
            else {
                console.error("Unexpected error:", error);
                toast.error("Something went wrong.");
            }
        }
    }

    return (
        <div className="adminPageMainContainer">
            <div className="sideBarContainer">
                <Sidebar />
            </div>

            <ConfirmDialog />

            <div className="adminPageParent">
                <div className="logoutBtnParent">
                    <Button
                        label="Logout"
                        icon="pi pi-sign-out"
                        iconPos="left"
                        className="logoutBtn"
                        severity="danger"
                        onClick={() => showConfirmLogoutDialog()}
                    />
                </div>
                <div style={{ flexGrow: "1", padding: "25px 22.5px", height: "100vh", 
                    overflowY: "auto" }}>
                    <Outlet />
                </div>
            </div>
        </div>
    )
}

export default Admin;

